<template>
    <div v-if="product">
        <product-editor :product-uuid="product.uuid" />
    </div>
    <div v-else>
        Produktet ble ikke funnet
    </div>
</template>

<script setup lang="ts">
import {useProducts} from '@/products/product.service'
import {computed} from 'vue'
import { Product } from './product.types'
import ProductEditor from '@/products/ProductEditor.vue'

const {getProductByUuid} = useProducts()

const props = defineProps({
    productUuid: {
        type: String,
        required: true
    }
})

const product = computed<Product |undefined>(() => {
    return getProductByUuid(props.productUuid)
})

</script>

<style scoped>

</style>